// import React, { useState, useEffect } from 'react';
// import Layout from '../Layout/Layout';
// import API_URL from '../../Config';
// import axios from 'axios';
// import { Link, useNavigate } from 'react-router-dom';
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, EffectCoverflow, Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/effect-coverflow";
// import "swiper/css/pagination";
// import '../../App.css';
// import { Splide, SplideSlide } from '@splidejs/react-splide';
// import '@splidejs/splide/dist/css/splide.min.css';


// const MoviesPage = () => {
//   const [categories, setCategories] = useState([]);
//   const [videoBanners, setVideoBanners] = useState([]);
//   const [bannerIndex, setBannerIndex] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const userid = sessionStorage.getItem("userId");
//   const navigate = useNavigate();

//   // Fetch banners
//   const fetchVideoBanners = async () => {
//     try {
//       const response = await axios.get(`${API_URL}/api/v2/getallvideobanners`);
//       setVideoBanners(response.data);
//     } catch (error) {
//       console.error('Error fetching video banners:', error);
//     }
//   };

//   // Fetch video containers
//   const fetchVideoContainer = async () => {
//     try {
//       const response = await axios.get(`${API_URL}/api/v2/getvideocontainer`);
//       setCategories(response.data);
//     } catch (error) {
//       console.error('Error fetching video container:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

// //   const fetchVideoContainer = async () => {
// //   try {
// //     const response = await axios.get(`${API_URL}/api/v2/getvideocontainer`);
// //     let fetchedCategories = response.data;

// //     // Collect LIVE videos (categoryid -1)
// //     const liveVideos = [];
// //     fetchedCategories.forEach((cat) => {
// //       cat.videoDescriptions.forEach((video) => {
// //         if (video.categorylist?.includes(-1)) {
// //           liveVideos.push(video);
// //         }
// //       });
// //     });

// //     // If LIVE videos exist, prepend LIVE category
// //     if (liveVideos.length > 0) {
// //       fetchedCategories = [
// //         {
// //           categoryid: -1,
// //           value: "LIVE",
// //           videoDescriptions: liveVideos,
// //         },
// //         ...fetchedCategories,
// //       ];
// //     }

// //     setCategories(fetchedCategories);
// //   } catch (error) {
// //     console.error("Error fetching video container:", error);
// //   } finally {
// //     setLoading(false);
// //   }
// // };

//   useEffect(() => {
//     fetchVideoBanners();
//     fetchVideoContainer();
//   }, []);

//   // Auto slide banners
//   useEffect(() => {
//     if (videoBanners.length > 0) {
//       const interval = setInterval(() => {
//         setBannerIndex((prevIndex) => (prevIndex + 1) % videoBanners.length);
//       }, 4000);
//       return () => clearInterval(interval);
//     }
//   }, [videoBanners]);

//   const handleEdit = (id, categoryid) => {
//     const item = { id, categoryid };
//     localStorage.setItem('items', JSON.stringify(item));
//     window.scrollTo(0, 0);
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <Layout>
//       {/* <div className="banner-container mt-3"> */}
//       <div className="banner-container mt-6 rounded-[10px] overflow-hidden">
//         {videoBanners.length > 0 ? (
//           // <div className="flex justify-center items-center">
//           <div className="w-screen px-0 mx-auto">
//             <Splide 
//               options={{
//                 type: 'loop',
//                 perPage: 1,
//                 focus: 'center',
//                 autoplay: true,
//                 interval: 4000,
//                 pauseOnHover: false,
//                 pauseOnFocus: false,
//                 speed: 800,
//                 gap: '6rem',
//                 padding: '10vw',
//                 arrows: false,
//                 pagination: true,
//                 lazyLoad: 'nearby',
//                 breakpoints: {
//             1024: {
//               padding: '10vw',
//             },
//             768: {
//               padding: '5vw',
//             }
//           }
//               }}
//               className="main-banner-splide"
//             >
//               {videoBanners.map((banner, index) => (
//                 <SplideSlide key={index}>
//                   <Link
//                     to={userid ? `/watchpage/${banner.videoId}` : "/UserLogin"}
//                     onClick={() => handleEdit(banner.videoId, banner.categoryid)}
//                   >
//                     <div className="w-full px-0 flex justify-center items-center">
//                       <img
//                       src={`${API_URL}/api/v2/${banner.videoId}/videoBanner`}
//                       alt={`Banner ${index}`}
//                       className="banner-image"
//                     />
//                     </div>

                  
//                   </Link>
//                 </SplideSlide>
//               ))}
//             </Splide>
//           </div>
//         ) : (
//           <div>No banners available</div>
//         )}
//       </div>

//       {/* Category Sliders */}
//       <div style={{marginTop:'70px'}}>
//         {categories.length === 0 ? (
//           <div>No content available</div>
//         ) : (
//           categories.map((category, index) =>
//             category.videoDescriptions?.length > 0 && (
//               <div key={index}>
//                 <h2 className="custom-label" style={{ paddingLeft: '20px', fontSize: '30px', margin: '0px' }}>
//                   {category.value}
//                 </h2>
//                 <div className="row" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
//                   <CategorySlider
//                     category={category}
//                     API_URL={API_URL}
//                     handleEdit={handleEdit}
//                     userid={userid}
//                   />
//                 </div>
//               </div>
//             )
//           )
//         )}
//       </div>
//     </Layout>
//   );
// };

// // Reusable slider like in AudioHomeScreen
// const CategorySlider = ({ category, API_URL, handleEdit, userid }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const slidesToShow = 6;
//   const totalSlides = category.videoDescriptions.length;

//   const goNext = () => {
//     if (currentIndex < totalSlides - slidesToShow) {
//       setCurrentIndex(currentIndex + 1);
//     }
//   };

//   const goPrev = () => {
//     if (currentIndex > 0) {
//       setCurrentIndex(currentIndex - 1);
//     }
//   };

//   return (
//     <div className="slider-container">
//   {/* LEFT overlay */}
//   {totalSlides > slidesToShow && currentIndex > 0 &&(
//     <button
//       className="side-nav left"
//       onClick={goPrev}
//       disabled={currentIndex === 0}
//       aria-label="Previous"
//     >
//       <i className="bi bi-chevron-left"></i>
//     </button>
//   )}

//   <div className="slider-track">
//     <div
//       className="slider-content"
//       style={{ transform: `translateX(-${currentIndex * (100 / slidesToShow)}%)` }}
//     >
//       {category.videoDescriptions.map((video) => (
//         <div key={video.id} className="item">
//           <Link
//             to={userid ? 
//               (category.categoryid === -1 ? `/livestream/${video.id}` : `/watchpage/${video.videoTitle}`) 
//               : "/UserLogin"}
//             onClick={() => handleEdit(video.id, category.categoryid)}
//           >
//             <div className="video-thumbnail-container">
//               {category.categoryid === -1 && <div className="live-badge">🔴 LIVE</div>}
//               <img
//                 src={`${API_URL}/api/v2/${video.id}/videothumbnail`}
//                 alt={video.videoTitle}
//                 loading="lazy"
//                 onError={(e) => {
//                   e.target.style.display = 'none';
//                   console.log('Failed to load thumbnail for:', video.videoTitle);
//                 }}
//               />
//             </div>
//           </Link>
//           <p className="title">{video.videoTitle}</p>
//         </div>
//       ))}
//     </div>
//   </div>

//   {/* RIGHT overlay */}
//   {totalSlides > slidesToShow && currentIndex < totalSlides - slidesToShow &&(
//     <button
//       className="side-nav right"
//       onClick={goNext}
//       disabled={currentIndex >= totalSlides - slidesToShow}
//       aria-label="Next"
//     >
//       <i className="bi bi-chevron-right"></i>
//     </button>
//   )}
// </div>

//   );
// };

// export default MoviesPage;



import React, { useState, useEffect } from 'react';
import Layout from '../Layout/Layout';
import API_URL from '../../Config';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import '../../App.css';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';

const MoviesPage = () => {
  const [categories, setCategories] = useState([]);
  const [videoBanners, setVideoBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const userid = sessionStorage.getItem("userId");
  const navigate = useNavigate();

  // Fetch banners
  const fetchVideoBanners = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/v2/getallvideobanners`);
      setVideoBanners(response.data);
    } catch (error) {
      console.error('Error fetching video banners:', error);
    }
  };

  // Fetch video containers
  const fetchVideoContainer = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/v2/getvideocontainer`);
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching video container:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVideoBanners();
    fetchVideoContainer();
  }, []);

  const handleEdit = (id, categoryid) => {
    const item = { id, categoryid };
    localStorage.setItem('items', JSON.stringify(item));
    window.scrollTo(0, 0);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Layout>
      {/* Banners */}
      <div className="banner-container mt-6 rounded-[10px] overflow-hidden">
        {videoBanners.length > 0 ? (
          <div className="w-screen px-0 mx-auto">
            <Splide
              options={{
                type: 'loop',
                perPage: 1,
                focus: 'center',
                autoplay: true,
                interval: 4000,
                pauseOnHover: false,
                pauseOnFocus: false,
                speed: 800,
                gap: '6rem',
                padding: '10vw',
                arrows: false,
                pagination: true,
                lazyLoad: 'nearby',
                breakpoints: {
                  1024: { padding: '10vw' },
                  768: { padding: '5vw' },
                },
              }}
              className="main-banner-splide"
            >
              {videoBanners.map((banner, index) => (
                <SplideSlide key={index}>
                  <Link
                    to={userid ? `/watchpage/${banner.videoId}` : "/UserLogin"}
                    onClick={() => handleEdit(banner.videoId, banner.categoryid)}
                  >
                    <div className="w-full px-0 flex justify-center items-center">
                      <img
                        src={`${API_URL}/api/v2/${banner.videoId}/videoBanner`}
                        alt={`Banner ${index}`}
                        className="banner-image"
                      />
                    </div>
                  </Link>
                </SplideSlide>
              ))}
            </Splide>
          </div>
        ) : (
          <div>No banners available</div>
        )}
      </div>

      {/* Category Sliders */}
      <div style={{ marginTop: '70px' }}>
        {categories.length === 0 ? (
          <div>No content available</div>
        ) : (
          categories.map(
            (category, index) =>
              category.videoDescriptions?.length > 0 && (
                <div key={index}>
                  <h2
                    className="custom-label"
                    style={{ paddingLeft: '20px', fontSize: '30px', margin: '0px' }}
                  >
                    {category.value}
                  </h2>
                  <div className="row" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    <CategorySlider
                      category={category}
                      API_URL={API_URL}
                      handleEdit={handleEdit}
                      userid={userid}
                    />
                  </div>
                </div>
              )
          )
        )}
      </div>
    </Layout>
  );
};

// Reusable slider
const CategorySlider = ({ category, API_URL, handleEdit, userid }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slidesToShow = 6;
  const totalSlides = category.videoDescriptions.length;

  const goNext = () => {
    if (currentIndex < totalSlides - slidesToShow) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="slider-container">
      {/* LEFT overlay */}
      {totalSlides > slidesToShow && currentIndex > 0 && (
        <button
          className="side-nav left"
          onClick={goPrev}
          disabled={currentIndex === 0}
          aria-label="Previous"
        >
          <i className="bi bi-chevron-left"></i>
        </button>
      )}

      <div className="slider-track">
        <div
          className="slider-content"
          style={{ transform: `translateX(-${currentIndex * (100 / slidesToShow)}%)` }}
        >
          {category.videoDescriptions.map((video) => {
            const isLive =
              category.value === "Live";

            return (
              <div key={video.id} className="item">
                <Link
                  to={
                    userid
                      ? isLive
                        ? `/prerecordedlive/${video.id}`
                        : `/watchpage/${video.videoTitle}`
                      : "/UserLogin"
                  }
                  onClick={() => handleEdit(video.id, category.categoryid)}
                >
                  <div className="video-thumbnail-container">
                    {isLive && (
                      <div className="live-badge">
                        <span className="live-dot"></span>LIVE
                      </div>
                    )}
                    <img
                      src={`${API_URL}/api/v2/${video.id}/videothumbnail`}
                      alt={video.videoTitle}
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                </Link>
                <p className="title">{video.videoTitle}</p>
              </div>
            );
          })}
        </div>
      </div>

      {/* RIGHT overlay */}
      {totalSlides > slidesToShow && currentIndex < totalSlides - slidesToShow && (
        <button
          className="side-nav right"
          onClick={goNext}
          disabled={currentIndex >= totalSlides - slidesToShow}
          aria-label="Next"
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      )}
    </div>
  );
};

export default MoviesPage;